export const RoutesReact = {
  ROOT: "/",
  DIRECTOR_LOGIN: "/login",
  DIRECTOR_DASHBOARD: "/dashboard",
  DIRECTOR_ATHLETES: "/dashboard/athletes",
  DIRECTOR_SPACES: "/dashboard/spaces",
  DIRECTOR_SPACE_ID: "/dashboard/spaces/:id",
  DIRECTOR_TEAM_ID: "/dashboard/spaces/:spaceId/teams/:id",
  DIRECTOR_ATHLETIC_TRAINERS: "/dashboard/athletic-trainers",
  DIRECTOR_NOTIFICATIONS: "/dashboard/notifications",
  DIRECTOR_USERS: "/dashboard/users",
  DIRECTOR_USER_ID: "/dashboard/users/:id",
  DIRECTOR_SUBJECT_READINESS: "/dashboard/subject-readiness",
  DIRECTOR_CALENDAR: "/dashboard/calendar",
  DIRECTOR_PROGRAMMING: "/dashboard/programming",
  DIRECTOR_CARICHI: "/dashboard/carichi",
  // ── Modulo Profiling (M4) ────────────────────────────────────────────────
  /** Hub atleta — 14 card P1-P14 + raggruppamenti F-V/Resistenza/Composizione */
  DIRECTOR_PROFILING_HUB_ATHLETE: "/dashboard/users/:athleteId/profiling",
  /** Dettaglio protocollo profilo (es. P1 VBT Lower con chart load-velocity) */
  DIRECTOR_PROFILING_PROTOCOL_DETAIL: "/dashboard/users/:athleteId/profiling/:protocolId",
  /** Storico esercizi atleta — 3 tab (Allenamento + Testing + Profiling) */
  DIRECTOR_ATHLETE_EXERCISE_HISTORY: "/dashboard/users/:athleteId/exercises/:exerciseId",
  // ── Coach Session Designer — Fase 3 (UI Session Builder) ───────────────
  /** Vista settimanale/mensile sessioni campo per un team */
  DIRECTOR_COACH_SESSIONS_WEEK: "/dashboard/teams/:teamId/sessions",
  /** Session Builder — dettaglio e composizione blocchi */
  DIRECTOR_COACH_SESSION_EDIT: "/dashboard/teams/:teamId/sessions/:sessionId/edit",
  // ── Coach Session Designer — Fase 4 ────────────────────────────────────
  DIRECTOR_MATCH_PAGE: "/dashboard/teams/:teamId/matches/:matchId",
  DIRECTOR_SESSION_POST: "/dashboard/teams/:teamId/sessions/:sessionId/post",
  // ── Fase 8 — Dashboard Statistiche Allenamento ──────────────────────────
  /** Dashboard statistiche per team: fasi, metodi, obiettivi, insights */
  DIRECTOR_TRAINING_STATS: "/dashboard/teams/:teamId/training-stats",
  // ── Modulo Allenamenti ─────────────────────────────────────────────────
  /** Pianificazione settimanale a blocchi di una squadra */
  DIRECTOR_ALLENAMENTI: "/dashboard/teams/:teamId/allenamenti",
  PROFILE: "/dashboard/profile",

  GYM_LOGIN: "/director/login",
  ATHLETE_LOGIN: "/athlete/login",
  GYM_REGISTER: "/gym/register",
  GYM_DASHBOARD: "/dashboard",
  DIRECTOR_CONFIRM: "/confirm-director",
  ATHLETE_CONFIRM: "/confirm-athlete",
  USER_CONFIRM: "/confirm-user",
  USER_GYM_CONFIRM: "/confirm-user-gym",
  GYM_CONFIRMED: "/confirmed-gym",
  GYM_PROFILE: "/gym/dashboard/profile",
  GYM_EDIT_PROFILE: "/gym/dashboard/edit-profile",
  GYM_ADD_ATHLETE: "/gym/dashboard/add-athlete",
  GYM_ADD_ATHLETE_ID: "/gym/dashboard/add-athlete/:id",
  GYM_ATHLETES: "/gym/dashboard/athletes",
  GYM_ATHLETE_ID: "/gym/dashboard/athletes/:id",
  GYM_ADD_WORKOUT_ATHLETE_ID: "/gym/dashboard/athletes/:id/add-workout",
  GYM_ACTIVITIES: "/gym/dashboard/activities",
  GYM_ACTIVITIES_BLOCKS: "/gym/dashboard/activities/blocks",
  GYM_ACTIVITIES_EXERCISES: "/gym/dashboard/activities/exercises",
  GYM_ACTIVITIES_PROGRAMS: "/gym/dashboard/activities/programs",
  GYM_ADD_BLOCK_PROGRAM: "/gym/dashboard/add-block-program",
  GYM_ADD_BLOCK_PROGRAM_ID: "/gym/dashboard/add-block-program/:id",
  GYM_ADD_PROGRAM: "/gym/dashboard/add-program",
  GYM_ADD_PROGRAM_ID: "/gym/dashboard/add-program/:id",
  GYM_ADD_GROUP: "/gym/dashboard/athletes/groups",
  GYM_ADD_GROUP_ID: "/gym/dashboard/athletes/groups/:id",
  // ── AI Coach (MVP) ─────────────────────────────────────────────────────
  DIRECTOR_AI_COACH: "/dashboard/ai-coach",
} as const;
